import {Box, CrossIcon, Grid, IconButton, LinkButton, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {tag2url} from '@yandex-delivery/utils'
import React, {memo} from 'react'

import * as classes from './BusinessPlateModal.classes'

type Props = {
  onActionButtonClick?: VoidFunction
  toggleModal: VoidFunction
}

export const BusinessPlateModal = memo<Props>(function BusinessBannerModal(props) {
  const {toggleModal, onActionButtonClick} = props
  const i18n = useI18n()

  return (
    <Paper className={classes.body} padding="none">
      <Box justifyContent="flex-end">
        <IconButton onPress={toggleModal} pb="xs" pt="xs" size="l" variant="ghost">
          <CrossIcon className={classes.closeIcon} />
        </IconButton>
      </Box>
      <Grid className={classes.texts}>
        <Typography color="invert" group="normal" mb="s" thickness="bold" variant="title3">
          {i18n('order.form.business-modal.title', 'Попробуйте Доставку для бизнеса, чтобы получить больше опций')}
        </Typography>
        <Typography color="invert" group="loose" mb="s" variant="body2">
          {i18n(
            'order.form.business-modal.caption-1',
            'Например, оплату расчётным счётом и доставки от двери до двери через пункты выдачи',
          )}
        </Typography>
        <Typography color="invert" group="loose" variant="body2">
          {i18n(
            'order.form.business-modal.caption-2',
            'Сделайте свой первый заказ из этой формы — мы создадим вам бизнес-профиль, чтобы вы могли пользоваться всеми возможностями Яндекс Доставки',
          )}
        </Typography>
      </Grid>
      <Box
        className={classes.image}
        mt="m"
        style={{backgroundImage: `url(${tag2url('delivery_order_business_modal_image')})`}}
      />
      <Grid className={classes.buttons}>
        <LinkButton
          className={classes.defaultButton}
          justifyContent="center"
          mb="xs"
          onPress={toggleModal}
          size="l"
          fullWidth
        >
          <Typography color="invert" group="normal" variant="body2">
            {i18n('order.form.business-modal.button', 'Спасибо, мне просто узнать')}
          </Typography>
        </LinkButton>
        <LinkButton onPress={onActionButtonClick} size="l" variant="action" fullWidth>
          {i18n('order.form.business-modal.action-button', 'Интересно, давайте попробуем')}
        </LinkButton>
      </Grid>
    </Paper>
  )
})
